import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { VendedorService } from '../../../../../shared/services/apis/pessoa/vendedor.service';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { VendedorHierarquiaStruct } from '../../../../../shared/services/structs/pessoa/vendedor-hierarquia.struct';
import { VendedorHierarquiaNodeStruct } from '../../../../../shared/services/structs/pessoa/vendedor-hierarquia-node.struct';

// Story, seção 6: modal "Hierarquia" — somente leitura, breadcrumb dos superiores + árvore de
// subordinados. Clicar num ancestral recarrega o próprio modal nele (sem fechar/reabrir).
@Component({
  selector: 'app-vendedor-hierarquia-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './vendedor-hierarquia-dialog.component.html',
  styleUrl: './vendedor-hierarquia-dialog.component.css',
})
export class VendedorHierarquiaDialogComponent implements OnInit {
  public isLoading = false;
  public idVendedor: number;
  public nome: string;
  public ancestrais: VendedorHierarquiaStruct[] = [];
  public subordinados: VendedorHierarquiaNodeStruct[] = [];
  public totalNaCadeia = 0;

  // Só o primeiro nível vem expandido por padrão (Story, seção 6).
  public expandido = new Set<number>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { idVendedor: number },
    public dialogRef: MatDialogRef<VendedorHierarquiaDialogComponent>,
    private vendedorService: VendedorService,
    private alertService: AlertService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.carregar(this.data.idVendedor);
  }

  public carregar(idVendedor: number): void {
    this.isLoading = true;
    this.vendedorService.getHierarquia(idVendedor).subscribe({
      next: res => {
        this.isLoading = false;
        if (res.isError) {
          this.alertService.show('Atenção', res.errorDescription || 'Erro ao carregar hierarquia.', AlertType.warning);
          return;
        }
        this.idVendedor = res.idVendedor;
        this.nome = res.nome;
        this.ancestrais = res.ancestrais;
        this.subordinados = res.subordinados;
        this.totalNaCadeia = res.totalNaCadeia;
        this.expandido = new Set(this.subordinados.map(s => s.idVendedor));
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Erro ao carregar hierarquia.', AlertType.error);
      }
    });
  }

  public toggleExpandido(idVendedor: number): void {
    if (this.expandido.has(idVendedor)) {
      this.expandido.delete(idVendedor);
    } else {
      this.expandido.add(idVendedor);
    }
  }

  public fechar(): void {
    this.dialogRef.close();
  }

  public editarCadastro(): void {
    this.dialogRef.close();
    this.router.navigate(['/cadastros/vendedor/cadastrar', { idVendedor: this.idVendedor }]);
  }
}
